import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LensCreatedData from "./LensCreatedData";
//import { defaultProps } from 'react-quill';

const LensCreationTable = (props) => {
  const navigate = useNavigate();

  const {
    combinedV,
    sphValue,
    cylValue,
    axisValue,
    SelectedAxis,
    addValue,
    fetchLensPowerData,
    GetdataForUpdate,
    GetdataForUpdateCopy,
  } = props;

  const PositonStatus = {
    position: "sticky",
    top: "0px",
    zIndex: "5",
  };

  console.log("addValue", addValue);
  console.log("combinedV", combinedV);
  console.log("sphValue", sphValue);

  const rows = document.querySelectorAll(".TrLensCreation");
  rows.forEach((row) => {
    row.addEventListener("click", () => {
      rows.forEach((r) => r.classList.remove("focused-row"));
      row.classList.add("focused-row");
    });
  });

  useEffect(() => {
    const handleArrowNavigation = (event) => {
      try {
        const arrowKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        if (arrowKeys.includes(event.key)) {
          event.preventDefault();
          const inputs = document.querySelectorAll(".tableBox");
          const currentIndex = Array.from(inputs).findIndex(
            (input) => input === document.activeElement
          );
          let newIndex;
          switch (event.key) {
            case "ArrowLeft":
              newIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex;
              break;
            case "ArrowRight":
              newIndex =
                currentIndex < inputs.length - 1
                  ? currentIndex + 1
                  : currentIndex;
              break;
            case "ArrowUp":
              newIndex =
                currentIndex - 7 >= 0 ? currentIndex - 7 : currentIndex;
              break;
            case "ArrowDown":
              newIndex =
                currentIndex + 7 < inputs.length
                  ? currentIndex + 7
                  : currentIndex;
              break;
            default:
              newIndex = currentIndex;
          }
          inputs[newIndex].focus();
        }
      } catch (error) {
        console.log(error);
      }
    };
    //document.addEventListener('keydown', handleArrowNavigation);
    return () => {
      //document.removeEventListener('keydown', handleArrowNavigation);
    };
  }, []);

  return (
    <div>
      {(() => {
        if (sphValue != null) {
          return (
            <div className="" id="table" style={{ display: "none" }}>
              {/* minWidth: "1127px"*/}
              <div
                className="tableDiv "
                style={{ maxHeight: "90vh", maxWidth: "92.5vw" }}
              >
                <table className="lensPowerTable">
                  <thead style={PositonStatus}>
                    {addValue &&
                      Array.isArray(addValue) &&
                      addValue.length > 0 &&
                      !(
                        addValue.length === 1 &&
                        (addValue[0] === "0.00" || addValue[0] === "0")
                      ) && (
                        <tr className="">
                          <th
                            colSpan="3"
                            className="headerCellStyle"
                            style={{
                              backgroundColor: "#5e709e",
                              fontWeight: "600",
                              color: "white",
                              textAlign: "center",
                            }}
                          >
                            Add -
                          </th>
                          {addValue.map((value4, index4) => (
                            <th
                              key={index4}
                              colSpan="6"
                              className="headerCellStyle"
                              style={{
                                backgroundColor: "#5e709e",
                                fontWeight: "600",
                                color: "white",
                                textAlign: "center",
                              }}
                            >
                              Add {value4}
                            </th>
                          ))}
                        </tr>
                      )}

                    <tr
                      className=""
                      style={{
                        justifyContent: "space-evenly",
                        backgroundColor: "#dee1e6",
                        height: "25px",
                      }}
                    >
                      <React.Fragment className="ButtonStick4">
                        <th
                          className="headerCellStyle ButtonStick1"
                          style={{
                            width: "0%",
                            padding: "3px",
                            paddingLeft: "10px",
                            margin: "2px",
                          }}
                        >
                          SPH
                        </th>
                        
                        <th
                          className="headerCellStyle  ButtonStick2"
                          style={{
                            width: "0%",
                            padding: "3px",
                            paddingLeft: "10px",
                            margin: "2px",
                          }}
                        >
                          CYL
                        </th>
                        <th
                          className="headerCellStyle  ButtonStick"
                          style={{
                            width: "0%",
                            padding: "3px",
                            paddingLeft: "10px",
                            margin: "2px",
                          }}
                        >
                          Axis
                        </th>
                      </React.Fragment>
                      {addValue &&
                        addValue.map((value4, index4) => (
                          <React.Fragment key={index4}>
                            <th className="headerCellStyle TabWidthMin">
                              Barcode
                            </th>
                            <th className="headerCellStyle TabWidthMin">
                              Box no
                            </th>
                            <th className="headerCellStyle TabWidthMin">
                              &nbsp;Alert qty
                            </th>
                            <th className="headerCellStyle TabWidthMin">
                              &nbsp;P Price
                            </th>
                            <th className="headerCellStyle TabWidthMin">
                              &nbsp;S Price
                            </th>
                            <th className="headerCellStyle TabWidthMin">
                              Init.Stk.
                            </th>
                          </React.Fragment>
                        ))}
                    </tr>
                  </thead>
                  <LensCreatedData
                    combinedV={combinedV}
                    addValue={addValue}
                    fetchLensPowerData={fetchLensPowerData}
                    GetdataForUpdate={GetdataForUpdate}
                    GetdataForUpdateCopy={GetdataForUpdateCopy}
                    axisValue={axisValue}
                    SelectedAxis={SelectedAxis}
                  />
                </table>
              </div>
            </div>
          );
        } else {
          console.log("not found");
          return null;
        }
      })()}
    </div>
  );
};

export default LensCreationTable;
